module.exports = __webpack_public_path__ + "media/images/icons/ic-clock-034eb04895f0c4aa8cb1810d147879a2.svg";